import { takeEvery, put, all } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import { loaderDecorator } from './decorators/loader-decorator';

import * as types from '../actions/user-account/types';
import * as actions from '../actions/user-account';
import { setUserFromAuthData } from '../actions/auth-user';

import httpStatusCodes from '../constants/http-status-codes';

import handleError from '../tools/error-helper';
import apiFetcher from '../tools/api-fetcher';

function* fetchCurrentAdministratorProfile() {
  yield put(actions.setUserProfileLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get('admins/users/administrators/current/profile');

    yield put(actions.setUserProfile(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setUserProfileLoading(false));
}

function* fetchCurrentSchoolUserProfile() {
  yield put(actions.setUserProfileLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get('schools/users/current/profile');

    yield put(actions.setUserProfile(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setUserProfileLoading(false));
}

function* updateCurrentAdministratorProfile({
  firstName,
  lastName,
  middleName
}) {
  yield put(actions.setUserProfileUpdating(true));
  const body = {
    firstName,
    lastName,
    middleName
  };

  try {
    yield apiFetcher
      .auth()
      .put('admins/users/administrators/current/profile', body);

    yield put(actions.fetchCurrentAdministratorProfile());
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setUserProfileUpdating(false));
}

function* updatePassword({ currentPassword, newPassword, onSubmitted }) {
  try {
    yield apiFetcher
      .auth()
      .put('users/current/password', { currentPassword, newPassword });
    toastr.success('Password was successfully updated.');

    yield put(actions.setUpdatePasswordError(null));
    onSubmitted();
  } catch (exception) {
    if (
      exception.response &&
      exception.response.status === httpStatusCodes.UnprocessableEntity &&
      exception.response.data &&
      exception.response.data.modelState['currentPassword']
    ) {
      yield put(
        actions.setUpdatePasswordError('Current password is incorrect')
      );
    } else {
      handleError(exception);
    }
  }
}

function* refreshAuthToken() {
  const { data } = yield apiFetcher.auth().get('auth-tokens/next');

  yield put(setUserFromAuthData(data));
}

function* updateEmail({ newEmail, onSubmitted }) {
  try {
    yield apiFetcher.auth().put('users/current/email', { newEmail });

    yield refreshAuthToken();

    toastr.success('Email was successfully updated.');

    yield put(actions.setUpdateEmailError(null));

    onSubmitted();
  } catch (exception) {
    if (
      exception.response &&
      exception.response.status === httpStatusCodes.Conflict
    ) {
      yield put(
        actions.setUpdateEmailError(
          'Such email is already registered for another user.'
        )
      );
    } else {
      handleError(exception);
    }
  }
}

function* updateUserAccountSettings({ accountSettings }) {
  yield put(actions.setSettingsUpdating(true));

  try {
    yield apiFetcher
      .auth()
      .put('users/current/account-settings', accountSettings);

    yield refreshAuthToken();
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setSettingsUpdating(false));
}

export default function* userAccountSaga() {
  yield all([
    takeEvery(
      types.USER_ACCOUNT_FETCH_CURRENT_ADMINISTRATOR_PROFILE,
      fetchCurrentAdministratorProfile
    ),
    takeEvery(
      types.USER_ACCOUNT_FETCH_CURRENT_SCHOOL_USER_PROFILE,
      fetchCurrentSchoolUserProfile
    ),
    takeEvery(
      types.USER_ACCOUNT_UPDATE_CURRENT_ADMINISTRATOR_PROFILE,
      updateCurrentAdministratorProfile
    ),
    takeEvery(
      types.USER_ACCOUNT_UPDATE_PASSWORD,
      loaderDecorator(updatePassword, actions.setIsUpdatingPassword)
    ),
    takeEvery(
      types.USER_ACCOUNT_UPDATE_EMAIL,
      loaderDecorator(updateEmail, actions.setIsUpdatingEmail)
    ),
    takeEvery(types.USER_ACCOUNT_UPDATE_SETTINGS, updateUserAccountSettings)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/user-account.js